import React from "react";
import { USPS } from "../data/site";
import { IMAGES } from "../data/site";

const USPSection = () => {
  return (
    <section className="bg-ink text-white" data-testid="usp-section">
      <div className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-7">
            <p className="overline text-white/60 mb-4">USPs</p>
            <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tightest font-bold leading-[0.95]">
              Grip where footballers
              <br />
              <span className="text-pritch-volt-trim">actually need it.</span>
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end">
            <p className="text-white/70 max-w-md leading-relaxed">
              Pritch is not a generic gym sock. Engineered around football boot movement — sprinting,
              turning, stopping, striking, and the repeated changes of direction matchday demands.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5 order-2 md:order-1">
            <div className="border border-white/15 aspect-[4/5] bg-white">
              <img
                src={IMAGES.productFeatures}
                alt="Pritch grip sock with technical feature callouts"
                className="w-full h-full object-cover"
                data-testid="usp-image"
              />
            </div>
          </div>
          <ul className="md:col-span-7 order-1 md:order-2 divide-y divide-white/10 border-t border-b border-white/10">
            {USPS.map((u) => (
              <li
                key={u.no}
                className="py-6 grid grid-cols-12 gap-4 items-start"
                data-testid={`usp-${u.no}`}
              >
                <span className="col-span-2 mono text-xs text-white/50 mt-1">{u.no}</span>
                <div className="col-span-10">
                  <h3 className="font-display uppercase text-xl md:text-2xl tracking-tight leading-tight">
                    {u.title}
                  </h3>
                  <p className="text-sm text-white/70 mt-2 max-w-xl">{u.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default USPSection;
